import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/pages/Login.vue";
import StudentManagement from "@/pages/StudentManagement.vue";
import StudentDetail from "@/pages/StudentDetail.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { requiresAuth: false },
  },
  {
    path: "/home",
    name: "StudentManagement",
    component: StudentManagement,
    meta: { requiresAuth: true, title: "学员管理" },
  },
  {
    path: "/home/:id",
    name: "StudentDetail",
    component: StudentDetail,
    meta: { requiresAuth: true, title: "学员详情" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 路由守卫 - 检查用户登录状态
router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem("userToken") !== null;

  // 记录最后访问（已登录才记录）
  if (isLoggedIn && to.path !== "/login") {
    sessionStorage.setItem("lastRoute", to.fullPath);
  }

  if (to.meta.requiresAuth && !isLoggedIn) {
    // 未登录，带 redirect 回登录
    next({
      path: "/login",
      query: { redirect: to.fullPath },
    });
    return;
  }

  if (to.path === "/login" && isLoggedIn) {
    // 已登录访问登录页，跳转到上次 or redirect or 默认学员管理页
    const redirect =
      from.query.redirect || sessionStorage.getItem("lastRoute") || "/home";
    next(redirect);
    return;
  }

  next();
});

export default router;
